import { z } from 'zod';

import {
  PAGINATION_PAGE_SIZE_DEFAULT,
  PAGINATION_SORT_DIRECTION,
} from '~/constants/pagination';

import {
  BOOLEAN_OPERATOR,
  FILTER_OPERATOR_BACKEND,
} from '~/models/filters/constants';

import { toSnakeCase } from '@vestigas/utils';

export const DELIVERY_NOTE_FILTER_NAMES = [
  'article_name',
  'article_number',
  'authorized_accounting_reference_id',
  'authorized_entity_type',
  'authorized_site_id',
  'billed_state',
  'buyer_id',
  'buyer_name',
  'category',
  'confirmed_accounting_reference_id',
  'confirmed_accounting_reference_name',
  'confirmed_site_id',
  'confirmed_site_name',
  'custom_field_global_level', // any custom field on the global level
  'custom_field_item_level', // any custom field on the item level
  'customer_number',
  'dln_accept_state',
  'dln_created_on',
  'dln_date',
  'dln_modified_on',
  'dln_nr',
  'is_mapped',
  'issuer_id',
  'issuer_name',
  'license_plate_number',
  'loading_location',
  'ou_id',
  'ou_name',
  'process_state',
  'recipient_id',
  'recipient_name',
  'search',
  'seller_id',
  'seller_name',
  'source',
  'submitted_by_user_id',
  'supplier_assigned_site_name',
  'supplier_id',
  'supplier_name',
] as const;

const DELIVERY_NOTES_SORT_FIELDS = [
  'created_on',
  'dln_date',
  'modified_on',
  'supplier_assigned_site_name',
  'supplier_name',
] as const;

export const zodFilterAggregatorSchema = z.enum(
  Object.values(BOOLEAN_OPERATOR),
);

export const zodFilterClauseSchema = z.object({
  caseSensitive: z.boolean().optional(),
  comp: z.enum(Object.values(FILTER_OPERATOR_BACKEND)),
  customFieldId: z.uuid().optional(),
  name: z.enum(DELIVERY_NOTE_FILTER_NAMES),
  value: z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.object({}),
    z.array(z.any()),
  ]),
});

export const zodFilterGroupItemSchema = z.object({
  filterClauses: z.array(zodFilterClauseSchema),
  filterAggr: zodFilterAggregatorSchema,
});

export const zodFilterConfigSchema = z.object({
  filterGroups: z.array(zodFilterGroupItemSchema).min(1),
  filterAggr: zodFilterAggregatorSchema,
});

export const zodFilteredDeliveryNotesPayloadSchema = z.object({
  filterConfig: zodFilterConfigSchema,
  limit: z
    .number()
    .gte(1)
    .lte(500)
    .optional()
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().nonnegative().optional().prefault(0),
  orderBy: z
    .preprocess(
      (value) => toSnakeCase(value),
      z.enum(DELIVERY_NOTES_SORT_FIELDS),
    )
    .optional()
    .prefault('dln_date'),
  sortOrder: z
    .preprocess(
      (value) => String(value).toUpperCase(),
      z.enum(PAGINATION_SORT_DIRECTION),
    )
    .optional()
    .prefault('DESC'),
});
